import { useNavigate } from "react-router-dom";

const FooterCopyright = () => {
  const navigate = useNavigate();

  return (
    <div className="hidden sm:flex items-center">
      <p className="text-sm font-normal">
        © {new Date().getFullYear()}
        <span
          role="button"
          className="text-white hover:drop-shadow ms-1.5 hover:underline"
          onClick={() => navigate("/")}
        >
          Seekler.net
        </span>
      </p>
    </div>
  );
};

export default FooterCopyright;
